// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8fb132bd","977":"b658b4ed"}[chunkId] + ".chunk.js";
};